/* PedalPadel add-ons: event delegation survives Shopify Theme Editor partial renders. */
(() => {
  if (window.__pedalPadelAddonsReady) return;
  window.__pedalPadelAddonsReady = true;
  window.ppSelectedAddons = window.ppSelectedAddons || { overgrip: null, protector: null };
  let activeModal = null;
  let returnFocus = null;
  let previousOverflow = '';

  const getCard = (type) => document.getElementById('pp-selected-' + type);

  const updateCard = (type) => {
    const item = window.ppSelectedAddons[type];
    const card = getCard(type);
    if (!card) return;
    card.hidden = !item;
    const img = card.querySelector('img');
    const name = card.querySelector('.pp-selected-addon__name');
    const price = card.querySelector('.pp-selected-addon__price');
    if (name) name.textContent = item?.name || '';
    if (price) price.textContent = item?.price ? '+ ' + item.price : '';
    if (img) {
      img.style.display = item?.image ? 'block' : 'none';
      if (item?.image) {
        img.src = item.image;
        img.alt = item.name || '';
      } else {
        img.removeAttribute('src');
        img.alt = '';
      }
    }
  };

  function closeModal() {
    if (!activeModal) return;
    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    activeModal = null;
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  }

  function openModal(id, trigger) {
    const modal = document.getElementById(id);
    if (!modal) return;
    closeModal();
    // A fixed element inside an animated/sticky Shopify section can be clipped.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    activeModal = modal;
    returnFocus = trigger;
    previousOverflow = document.body.style.overflow;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    (modal.querySelector('.pp-addon-select-product') || modal.querySelector('.pp-addon-modal__close'))?.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.pp-addon-trigger[data-modal-target]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger.dataset.modalTarget, trigger);
      return;
    }

    const select = event.target.closest('.pp-addon-select-product[data-addon-type]');
    if (select) {
      event.preventDefault();
      const type = select.dataset.addonType;
      if (type !== 'overgrip' && type !== 'protector') return;
      const variantId = Number(select.dataset.variantId);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
      window.ppSelectedAddons[type] = {
        variantId: String(variantId),
        name: select.dataset.productName || '',
        price: select.dataset.productPrice || '',
        image: select.dataset.productImage || ''
      };
      updateCard(type);
      closeModal();
      return;
    }

    const remove = event.target.closest('[data-remove-addon]');
    if (remove) {
      event.preventDefault();
      const type = remove.dataset.removeAddon;
      if (type !== 'overgrip' && type !== 'protector') return;
      window.ppSelectedAddons[type] = null;
      updateCard(type);
      return;
    }

    if (event.target.closest('.pp-addon-modal [data-close-modal]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    }
    // Keep keyboard navigation within the active dialog.
    if (event.key === 'Tab') {
      const els = [...activeModal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')].filter(el => el.offsetParent !== null);
      if (!els.length) return;
      const first = els[0];
      const last = els[els.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  // Ajax cart submissions reset window.ppSelectedAddons in product-form.js.
  document.addEventListener('shopify:section:load', () => {
    ['overgrip', 'protector'].forEach(updateCard);
  });
})();
